<div class="header bg-white d-flex justify-content-between align-items-center p-px-24">
  <app-custom-breadcrumb [listUrls]="listUrls"></app-custom-breadcrumb>
  <div class="d-flex">
    <app-button text="Annuler" (click)="goBack()" class="mr-px-8" [stroked]="true"></app-button>
    <app-button [text]="mission ? 'Modifier le brouillon' : 'Enregister un brouillon'" class="mr-px-8"
      [disabled]="loading" [loading]="loading" (handleClick)="draftMission()"></app-button>
    <app-button [text]="mission ? 'Publier' : 'Publier la mission'" [disabled]="formGroup.invalid || loading"
      [loading]="loading" (handleClick)="addMission()"></app-button>
  </div>
</div>
<div [formGroup]="formGroup" class="bg-white" style="margin-bottom: -22px">
  <div class="d-flex flex-wrap border-top border-1">
    <div class="col-12 col-md-5 p-px-32 border-right">
      <app-text-separator text="Général"></app-text-separator>
      <app-custom-input label="Référence de la mission" [parentForm]="formGroup" controlName="missionTitle"
        innerClass="my-px-16" [required]="true"></app-custom-input>

      <app-custom-drop-down class="mt-px-16" label="Site" [required]="true" [parentForm]="formGroup"
        [options]="siteList" controlName="adresseId"></app-custom-drop-down>

      <app-custom-drop-down class="mt-px-16" label="Service d’affectation" [required]="true" [multiple]="false"
        controlName="serviceAffectationId" [options]="affectationServiceList"
        [parentForm]="formGroup"></app-custom-drop-down>
      <app-custom-drop-down class="mt-px-16" label="Fiche de poste" [required]="true" [multiple]="false"
        controlName="fichePosteId" [options]="fichePostesList" [parentForm]="formGroup"></app-custom-drop-down>
      <app-custom-drop-down controlName="isurgent" class="mt-px-16" label="Priorité de la mission" [required]="true"
        [options]="priorityMissionOptions" [parentForm]="formGroup"></app-custom-drop-down>

      <!--      <app-custom-drop-down-->
      <!--        class="mt-px-16"-->
      <!--        label="Acceptation du candidat"-->
      <!--        [required]="true"-->
      <!--        [options]="acceptationCandidantOptions"-->
      <!--      ></app-custom-drop-down>-->

      <app-text-separator innerClass="mt-px-32" text="spécifications de la mission"></app-text-separator>

      <app-custom-drop-down label="Secteur" controlName="typeSecteurId" class="mt-px-16" [options]="secteurList"
        [parentForm]="formGroup" [required]="true"></app-custom-drop-down>

      <app-custom-drop-down class="mt-px-16" label="Poste" [required]="true" controlName="typePosteId"
        [options]="posteList" [parentForm]="formGroup"></app-custom-drop-down>

      <app-custom-drop-down class="mt-px-16" label="Type de contrat" [required]="true" [options]="typeContratOptions"
        [parentForm]="formGroup" controlName="typecontat" [withSearch]="false"></app-custom-drop-down>

      <div class="row my-3" *ngIf="formGroup.get('typecontat')?.value === 'LIBERAL'">
        <mat-label>Choix de la gestion administrative de l’intérim</mat-label>
        <app-custom-checkbox [label]="'Par Collary'" [value]="'COLLARY'"
          [checked]="formGroup.get('platformManagedBy')?.value == 'COLLARY'"
          (change)="checkBoxChange($event, 'COLLARY')"></app-custom-checkbox>

        <app-custom-checkbox [label]="'Par votre établissement'" [value]="'YOURSELVES'"
          (change)="checkBoxChange($event, 'YOURSELVES')"
          [checked]="formGroup.get('platformManagedBy')?.value == 'YOURSELVES'"></app-custom-checkbox>
      </div>
    </div>
    <div class="col border-left p-px-32">
      <app-custom-input label="Description" innerClass="my-px-16" [required]="true" [parentForm]="formGroup"
        [max]="1000" controlName="description" type="textarea" [errorMessage]="
          'Ecrivez au moins 50 caractères et maximum 1000 caractères'
        "></app-custom-input>
      <app-text-separator innerClass="mt-px-32" text="Dates et horaires"></app-text-separator>
      <div class="row mt-px-16">
        <div class="col-12 col-md-6">
          <app-custom-datepicker [parentForm]="formGroup" [minDate]="today" [label]="'Date de début de la mission'"
            [controlName]="'startdate'" [errorMessage]="errorMessageStartDate"></app-custom-datepicker>

          <app-custom-datepicker [parentForm]="formGroup" innerClass="mt-px-17" [minDate]="startDate"
            [label]="'Date de fin de la mission'" [controlName]="'enddate'"
            [errorMessage]="errorMessageEndDate"></app-custom-datepicker>
        </div>
        <div class="col-12 col-md-6">
          <div>
            <mat-label>Heure de début de la mission

              <span class="required">*</span>
            </mat-label>
            <input class="form-control" type="time" formControlName="starttime" />
          </div>
          <div class="mt-px-22">
            <mat-label>Heure de fin de la mission
              <span class="required">*</span>
            </mat-label>
            <input class="form-control" formControlName="endtime" type="time" />
          </div>
        </div>
      </div>
      <app-text-separator innerClass="mt-px-32" text="Rénumération"></app-text-separator>
      <app-custom-input [label]="
          formGroup.get('typecontat')?.value == 'LIBERAL'
            ? 'Rénumération journalière'
            : 'Salaire mensuel'
        " [parentForm]="formGroup" controlName="compensationproposednet" innerClass="my-px-16" [errorMessage]="
          'La valeur minimum est de 50 et la valeur maximum 9999 euro'
        " type="text" inputmode="decimal" [decimalOnly]="true" currency="EUR" [required]="true"></app-custom-input>

      <app-text-separator innerClass="mt-px-32"
        text="Primes et Prise en charge des frais de mission"></app-text-separator>
      <div class="row my-3">
        @for (item of ChargeList; track item.controlName) { @if (item.display) {
        @switch (item.type) { @case ('checkbox') {
        <div [ngClass]="{ 'ml-px-16': item.isSecond }">
          <app-custom-checkbox [label]="item.label" [formGroup]="formGroup"
            [controlName]="item.controlName"></app-custom-checkbox>
        </div>

        } @case ('radio') {

        <div [ngClass]="{ 'ml-px-16': item.isSecond }" class="d-flex flex-column">
          <mat-label>{{ item.label }}</mat-label>
          <mat-radio-group aria-label="Select an option" [formControlName]="item.controlName">
            <mat-radio-button [value]="opt.value" *ngFor="let opt of item.options">{{ opt.label }}</mat-radio-button>
          </mat-radio-group>
        </div>
        } @case ('textarea') {
        <div [ngClass]="{ 'ml-px-16': item.isSecond }">
          <app-custom-input [label]="item.label" innerClass="my-px-16" [required]="false" [parentForm]="formGroup"
            [max]="1000" [controlName]="item.controlName" type="textarea"></app-custom-input>
        </div>
        } } } }
      </div>
      <app-text-separator innerClass="mt-px-32" text="Photos du service d’affectation"></app-text-separator>
      <!--    <app-custom-dragdrop-image-->
      <!--      (sendImage)="getImage($event)"-->
      <!--      imageContainerWidth="350px"-->
      <!--      [url]="imageUrls"-->
      <!--      [isDeletble]="true"-->
      <!--      [singleImage]="true"-->
      <!--      [limit]="5"-->
      <!--    ></app-custom-dragdrop-image>-->
      @if(imageUrls.length) {
      <div class="d-flex gap-2 mt-px-16">
        @for (img of imageUrls; track $index) {
        <img [src]="displayImg(img)" class="mission-img" alt="" (click)="openImage(displayImg(img))" />
        }
      </div>
      } @else {
      <div class="text-secondary text-center mt-px-16">
        Le site ne dispose pas d'image actuellement
      </div>
      }
    </div>
  </div>
</div>
